<template>
  <div class="flex flex-row bg-gray-800 p-1 rounded-md">
    <div
      v-for="option in options"
      :key="option.key"
      @click="$emit('update', option.key)"
      class="w-full flex gap-2 text-sm items-center justify-center rounded-md py-1 px-2 cursor-pointer whitespace-nowrap"
      :class="[
        modelValue === option.key
          ? 'bg-gray-700 text-text-primary'
          : 'text-text-secondary bg-gray-800',
      ]"
    >
      {{ option.label }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update']);
</script>
